/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {Component, Vue} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';

const namespace: string = 'userSessionModule';

/**
 * Logout view.
 *
 * @author jgeorgiadou@frontier.co.uk
 */

@Component({
    name: 'v-logout',
})

export default class Logout extends Vue {
    // Logout
    @Action('logout', {namespace})
    public logout!: () => void;
    // Get current view name
    @Getter('getCurrentView', {namespace})
    public getCurrentView!: {name: string, param?: any} | undefined;

    private timeout: number = 0;

    /**
     * Mounted life-cycle event.
     */
    public mounted(): void {
       this.timeout = window.setTimeout(() => {
           this.logout();
           const view: any = undefined !== this.getCurrentView ? this.getCurrentView : 'home';
           this.$router.push(view);
        }, 300);

    }

    /**
     * Destroyed lifecycle hook
     */
    public async destroyed(): Promise<void> {
        window.clearTimeout(this.timeout);
    }

}
